import React from "react";
import { VerifyEmail } from "../../components/CreateAccountVerifyEmail/VerifyEmail";

const VerifyEmailPage = (): React.ReactElement => <VerifyEmail />;

export default VerifyEmailPage;
